module.exports = __webpack_public_path__ + "static/media/appstore-badge-mobile.1d601c26.svg";